"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mutations = void 0;

var _slicedToArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));

var mutations = {
  SET_SELECTED_TRUCK: function SET_SELECTED_TRUCK(state, data) {
    state.selectedTruck = data || null;
  },
  SET_PLAN_DATE_RANGE: function SET_PLAN_DATE_RANGE(state, data) {
    state.planDateRange = data;
  },
  SET_CORE_INFORMATION: function SET_CORE_INFORMATION(state, data) {
    var _data = (0, _slicedToArray2.default)(data, 1),
        trucks = _data[0];

    state.trucks = trucks ? trucks : [];
  },
  SET_TABLE_LOADING: function SET_TABLE_LOADING(state, data) {
    state.tableLoading = data;
  },
  SET_PLAN: function SET_PLAN(state, data) {
    state.plan = data && data['data'] && data['data']['data'] ? data['data']['data'] : data;
  },
  SET_ANY_CHANGES: function SET_ANY_CHANGES(state, data) {
    state.anyChanges = data;
  },
  SET_PLAN_EXISTS: function SET_PLAN_EXISTS(state, data) {
    state.isPlanExists = data;
  },
  SET_TRUCK_FILTERS: function SET_TRUCK_FILTERS(state, data) {
    state.truckFilters = data || [];
  },
  SET_TRUCK_LOADING: function SET_TRUCK_LOADING(state, data) {
    state.truckLoading = data;
  },
  SET_SELECTED_PROJECTS: function SET_SELECTED_PROJECTS(state, data) {
    state.selectedProjects = data || [];
  },
  SET_SELECTED_CUSTOMERS: function SET_SELECTED_CUSTOMERS(state, data) {
    state.selectedCustomers = data || [];
  },
  SET_SELECTED_TRUCKS: function SET_SELECTED_TRUCKS(state, data) {
    state.selectedTrucks = data || [];
  }
};
exports.mutations = mutations;